import { BehaviorSubject } from "rxjs";
import { filter } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, NavigationEnd, Router } from "@angular/router";

import { STRING } from "../../../constants/string";
import { AppRoute, AppRouteBreadcrumb, AppRouteData } from "../../../types";

const getPathOfRoute = ({ firstChild, url, data }: ActivatedRouteSnapshot, parentUrl: string[] = []): AppRoute[] => {
  const list: AppRoute[] = [];
  // Construct the route URL
  const routeUrl = parentUrl.concat(url.map(url => url.path));

  if (url.length) {
    list.push({
      data: data as AppRouteData,
      path: `${STRING.SLASH}${routeUrl.join(STRING.SLASH)}`,
    });
  }

  // Add another element for the next route part
  return list.concat(firstChild ? getPathOfRoute(firstChild, routeUrl) : []);
};

export interface Breadcrumb {
  label: string
  url: string
}

@Injectable({
  providedIn: "root",
})
export class MedBreadcrumbService {
  constructor(private router: Router) {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      // Construct the breadcrumb hierarchy
      const { routerState: { snapshot: { root } } } = this.router;

      if (root === null) {
        return;
      }

      const breadcrumbs: Breadcrumb[] = getPathOfRoute(root)
        .filter(({ data }: AppRoute) => data && data.breadcrumb)
        .map(({ path, data }: AppRoute) => ({
          label: this._getLabel(data.breadcrumb),
          url: path,
        }));

      this._breadcrumbs$.next(breadcrumbs);
    });
  }

  // Subject emitting the breadcrumb hierarchy
  private readonly _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);
  // Observable exposing the breadcrumb hierarchy
  readonly breadcrumbs$ = this._breadcrumbs$.asObservable();

  private _getLabel({ alias }: AppRouteBreadcrumb = { alias: "UNDEFINED ROUTE" }): string {
    return alias;
  }
}
